import React from "react";
import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";
import AnimatedText from "../../component/Text/animationText";

import './style.css'

const LandingPage: React.FC = () => {
  const textArray = ["Hello", "Hola","Hallo", "Cześć", "Hej", "Merhaba"];

  return (
    <Jumbotron minWidth="100%" flexDirection="row" justifyContent="center" >
      <Jumbotron
        flexDirection="column"
        minWidth="300px"
        width="350px"
        margin="0px"
        height="100vh"
        justifyContent="center"
        textAlign="left"
      >
        <AnimatedText textArray={textArray} fs="80px" fontWeight="300" />
        <Text text="I am Rajan" fs="24px" padding="0px" />
        <Text text="Full Stack web developer" fs="24px" padding="0px" />
      </Jumbotron>

      <Jumbotron
        minWidth="300px"
        width="450px"
        height="100vh"

        justifyContent="center"
        textAlign="left"
        alignItems="center"
      >
        <img className="myImage" width="450px" height="auto" alt="me" src="meWithCloud.png" />
      </Jumbotron>
    </Jumbotron>
  );
};

export default LandingPage;
